import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as globalAdd from '../../../connectionString';
import { CreateGroupModal } from '../models/CreateGroup.model';

@Injectable()
export class HaCasegroupcreationServiceService {

  constructor(private http: HttpClient) { }
  getCaseGroupList() {
    return this.http.get(globalAdd.Paneladdress + 'api/Ha/CaseSharing/caseGroupList');
  }

  createGroup(groupTextValue) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/createGroup', { groupTextValue: groupTextValue });
  }

  getCodesByGroups(caseGroupId){
    return this.http.get(globalAdd.Paneladdress + 'api/Ha/CaseSharing/getCodesByGroup?caseGroupId='+ caseGroupId );
  }

  updateCaseItem(id, name, desc, index) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/UpdateCaseItem', { id: id, name: name, desc: desc, index: index });
  }

  getCodesByGroup() {
    return this.http.get(globalAdd.Paneladdress + 'api/Ha/CaseSharing/getCodes');
  }

  saveIcd(icdText, icdDescText, groupId) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/saveIcd', { icdText: icdText,icdDescText: icdDescText,groupId: groupId });
  }

  saveCpt(cptText, cptDescText, groupId) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/saveCpt', { cptText: cptText,cptDescText: cptDescText,groupId: groupId });
  }

  savePreop(text, groupId) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/savePreop', { text: text, groupId: groupId });
  }

  saveProc(text, groupId) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/saveProc', { text: text, groupId: groupId });
  }

  saveMed(text, groupId) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/saveMed', { text: text, groupId: groupId });
  }

  saveCodes(name, desc, index) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/CreateCaseItem', { name: name, desc: desc, index: index });
  }

  createGroupAndCodes(groupModal: CreateGroupModal) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/createGroupAndCodes',groupModal);
  }

  updateCaseGroupName(groupId, groupName) {
    return this.http.post(globalAdd.Paneladdress + 'api/Ha/CaseSharing/updateCaseGroupName', { groupId: groupId, groupName: groupName});
  }

  deleteCaseGroup(groupId) {
    return this.http.get(globalAdd.Paneladdress + 'api/Ha/CaseSharing/deleteCaseGroup?groupId='+ groupId);
  }
}
